import React, { useState } from 'react'
import LoadingError from '../../components/LoadingError'
import { FactorConversion } from '../../utils/conversions'
import { UnitConversionsContext } from './UnitConversionsContext'
import { LoadingCircular } from '../../components/LoadingCircular'
import { useUnitConversionsQuery } from '../../graphql/api/queries/GetUnitConversions.generated'
import { PREFERRED_AREA_UNIT } from '../../constants/preferences'

const UnitConversionsContextProvider: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const [error, setError] = useState<Error | null>(null)
  const [unitConversions, setUnitConversions] = useState<ReadonlyArray<FactorConversion>>([])

  const { loading } = useUnitConversionsQuery({
    fetchPolicy: 'cache-first',
    onError: setError,
    onCompleted: ({ unitConversions }) => setUnitConversions(unitConversions?.entities || []),
    variables: {
      filterOperatorType: 'OR',
      filter: [
        { key: 'unitId', type: 'EQ', value: PREFERRED_AREA_UNIT.ac },
        { key: 'unitId', type: 'EQ', value: PREFERRED_AREA_UNIT.ha },
        { key: 'convertToUnitId', type: 'EQ', value: PREFERRED_AREA_UNIT.ha },
        { key: 'convertToUnitId', type: 'EQ', value: PREFERRED_AREA_UNIT.ac },
      ],
    },
  })

  if (loading) return <LoadingCircular />

  if (error) return <LoadingError errorText={error.message} />

  return <UnitConversionsContext.Provider value={unitConversions}>{children}</UnitConversionsContext.Provider>
}

export default UnitConversionsContextProvider
